import './QASection.scss';
import QastionsAnswers from 'components/QastionsAnswers/QastionsAnswers';
import { getIndividualClientText, getBusinessesClientText } from 'constants/QAText';
import { useTranslation } from 'react-i18next';

const QASection = () => {
    const { t } = useTranslation();
    return (<div className="qa-section-container" id="qa">
        <h2 className="main-title">{t("titles.FAQ")}</h2>
        <div className="qa-container">
            <QastionsAnswers questionsArr={getIndividualClientText().blocks} title={getIndividualClientText().title} />
            <QastionsAnswers questionsArr={getBusinessesClientText().blocks} title={getBusinessesClientText().title} />
        </div>
    </div>

    )
};

export default QASection;